import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ErrorStateService } from '@fgb/core';

@Component({
  selector: 'fgbcl-error',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
})
export class ErrorComponent {
  private errorService: ErrorStateService = inject(ErrorStateService);
  error$ = this.errorService.error$;

  addError(err: any) {
    this.errorService.setError(err);
  }

  clear() {
    this.errorService.clear();
  }
  
}
